import styles from './styles/Trend.module.scss';
import cn from 'classnames';

export default function Trend({ value }: { value: number }) {
  return (
    <div
      className={cn(styles.Trend, {
        [styles.Up]: value > 0,
        [styles.Down]: value < 0
      })}
    >
      {value > 0 && <>+ {value}</>}
      {value < 0 && <>- {Math.abs(value)}</>}
      {value == 0 && (
        <svg width="14" height="14" viewBox="0 0 14 14">
          <text transform="translate(0 11)" fill="#000" fontSize="14" fontWeight="900" fontFamily="Helvetica">
            <tspan x="0" y="0">
              —
            </tspan>
          </text>
        </svg>
      )}
    </div>
  );
}
